<template>
  <div id="app">
    <top v-if="$route.meta.showTop"/>
    <router-view/>
    <bottom v-if="$route.meta.showBottom"/>
  </div>
</template>

<script>

import Top from '@/components/Top'
import Bottom from '@/components/Bottom'

export default {
  name: 'App',
  components: {
    Top,
    Bottom
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#app{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  margin: 0 auto;
}
html,body,#app{
  height: 100%;
  /* background: #f3f4f7;*/
  // user-select none;
  -webkit-user-select: text;
}
* {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

ul, li {
  padding: 0;
  margin: 0
}

a {
  color: black;
  text-decoration: none;
}

.whole{
  width:90%;margin: 0 auto;
  height: auto;padding: 5px 0 2px 0;
}
.titexte{
  line-height: 34px;
  background:#4595E6;
  float:left;width: 100%;font-weight: 800;
}
/*全局TitleCSS*/
.title-layout {
  height: 34px;
  /* background-color: #4595E6;*/
  color: white;
  border-radius: 5px 5px 0 0;
}
.title-left {
  float left;
  margin-left 20px;
}
.title-layout span {
  height: 34px;
  line-height: 34px;
  font-weight: bold;
  font-size: 16px;
}

/*全局TitleCSS*/
.dialog-title {
  width: 100%;
  height: 35px;
  background-color: #4595E6;
  font-size: 15px;
  line-height: 35px;
  color: white;
  text-align: center;
  font-weight: bold;
  display inline-block
}

.dialog-close {
  cursor: pointer;
  float right;
  margin-right 10px
}

/*全局DialogCSS*/
.dialog-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 500;
}

.dialog-inner {
  width: 48%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  z-index: 501;
  background-color: white;
}
.dialog-innerr {
  width: 85%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  z-index: 501;
  background-color: white;
}
.dialog-image {
  width: 85%;
  margin-left:8%
  margin-top 5px
  margin-bottom 5px
  height: 100%;
}
.el-scrollbar__wrap {
  /* overflow: scroll; */
  height: 100%;
}

/*全局DialogCSS*/

/*全局图片CSS*/
.image-layout-left {
  width: 28%;
  float: left;
  margin: 0 auto 0 4%;
}

.image-layout-left img {
  width: 100%;
  height: 100%;
  border: 1px solid #aaa;
  cursor: pointer;
}

.image-layout-left span {
  text-align: center;
  display: block;
  height: 35px;
  font-size: 13px;
  line-height: 35px;
}

.image-layout-middle {
  width: 28%;
  float: left;
  margin: 0 4%;
}

.image-layout-middle img {
  width: 100%;
  height: 100%;
  border: 1px solid #aaa;
  cursor: pointer;
}

.image-layout-middle span {
  text-align: center;
  display: block;
  height: 35px;
  font-size: 15px;
  line-height: 35px;
}

.image-layout-right {
  width: 28%;
  float: right;
  margin: 0 4% 0 auto;
}

.image-layout-right img {
  width: 100%;
  height: 100%;
  border: 1px solid #aaa;
  cursor: pointer;
}

.image-layout-right span {
  text-align: center;
  display: block;
  height: 35px;
  font-size: 15px;
  line-height: 35px;
}

/*全局图片CSS*/

/*全局地图时间CSS*/
.mapTime {
  display: inline-block;
  font-size: 15px;
  color: #ff0000;
  margin-left: 10px;
  cursor: pointer;
  float: left;
  text-decoration: underline;
}

.mapTimeColor {
  color: #000000;
}

/*全局地图时间CSS*/
.mapTableButton {
  display: inline-block;
  font-size: 15px;
  color: #003366;
  margin-right: 10px;
  cursor: pointer;
  font-weight: bold;
  float: right;
  text-decoration: underline;
}

.mapTableButtonColor {
  color: #ff0000;
  text-decoration: none;
}

/*全局地图CSS*/
.table-container,
.map-container {
  position: relative;
  height: 700px;
  border-top: 1px solid #aaa;
  margin-top: 5px;
}

.map {
  width: 100%;
  height: 100%;
}

.map-legend {
  display inline-block
  position absolute
  bottom 0
  right 0
  width 7%
  border 1px solid #aaa
}

.map-title {
  position: absolute;
  top: 10px;
  left: 10px;
  font-weight: bold;
  font-size: 15px;
}

/*全局地图CSS*/

.clearFix:after {
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}

.clearFix {
  zoom: 1;
}

.ol-scale-line {
  background: rgba(0, 60, 136, 0.5);
  border-radius: 5px;
  position: absolute;
  bottom: 15px;
  left: 15px;
}

.ol-scale-line-inner {
  border: 1.5px solid #eee;
  border-top: none;
  color: #eee;
  font-size: 10px;
  text-align: center;
  margin: 4px;
  will-change: contents, width;
}

.el-scrollbar__wrap {
  overflow-x: hidden;
}

.el-radio__input,
.el-radio__input{
  height 34px;
  line-height 34px;
}

.el-dropdown-menu__item {
  color: #1262b3 !important;
}
.el-dropdown-menu__item--divided {
  border-top: 1px solid #000 !important;
}
.el-dropdown-menu__item--divided:before {
  background-color: #bfdfff !important;
}

.elTitle{
  text-align:center !important;
  font-weight: bold !important;
  background: #bfdfff !important;
  width: 90px !important;
  font-size: 13px !important;
}
.el-scrollbar__wrap {
  overflow: inherit;
  height: 100%;
}


.el-input__inner {
  height:35px;
  line-height:35px;
}

.el-loading-mask {
  position: absolute;
  z-index: 2000;
  /* background-color: rgba(255,255,255,.9); */
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: opacity .3s;
  transition: opacity .3s;
}

.el-slider__button {
  width: 11px !important ;
  height: 10px !important;
}
.el-slider__stop{
  background:#000;
}
</style>
